import { Component, Input, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { WidgetComponent } from 'app/widget/widgets/widget-component';
import { Subscription } from 'rxjs';
import { StoreService } from 'core/services';
import { UtilsWidgetService } from '../services/utils-widget.service';

@Component({
  selector: 'lms-progress-sections-widget',
  templateUrl: './progress-sections-widget.component.html',
  styleUrls: ['./progress-sections-widget.component.scss']
})
export class ProgressSectionsWidgetComponent implements WidgetComponent, OnInit, OnChanges, OnDestroy {
  @Input() data: any;
  @Input() progressSections: any;
  @Input() key?: string;

  public labels: string[] = ['0%', '20%', '40%', '60%', '80%', '100%'];
  public colors: { backgroundColor: string[] } = {
    backgroundColor: ['#007eff', '#007eff', '#007eff', '#007eff', '#007eff', '#007eff']
  };
  public options: any = {
    scales: {
      x: { grid: { display: false } }
    }
  };
  public tooltipText: string;
  public labelLegend: string = 'groups.dashboard.students';
  private tooltipSubscription: Subscription = new Subscription();

  constructor() {}

  public ngOnInit(): void {
    this.tooltipSubscription = StoreService.get(this.data.action).subscribe((tooltipObject) => {
      this.tooltipText = UtilsWidgetService.containTooltip(tooltipObject, this.data.action, this.key);
    });
  }

  public ngOnChanges(): void {
    if (
      this.progressSections &&
      this.progressSections.length &&
      (Math.max(...this.progressSections) < 10 || Math.max(...this.progressSections) % 2 === 1)
    )
      this.options = {
        ...this.options,
        scales: {
          x: { grid: { display: false } },
          y: { ticks: { stepSize: 1 } }
        },
        height: 250
      };
  }

  public ngOnDestroy(): void {
    this.tooltipSubscription.unsubscribe();
  }
}
